import { render } from "./SolutionCustomerList.vue?vue&type=template&id=ab610e48&scoped=true"
import script from "./SolutionCustomerList.vue?vue&type=script&lang=js"
export * from "./SolutionCustomerList.vue?vue&type=script&lang=js"

import "./SolutionCustomerList.vue?vue&type=style&index=0&id=ab610e48&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab610e48"],['__file',"src/views/h5/ai/solution/SolutionCustomerList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ab610e48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ab610e48', __exports__)) {
    api.reload('ab610e48', __exports__)
  }
  
  module.hot.accept("./SolutionCustomerList.vue?vue&type=template&id=ab610e48&scoped=true", () => {
    api.rerender('ab610e48', render)
  })

}


export default __exports__